/**
 * Deep I: three stills. Each hopper of boulders drips through slime onto a magic wall, and the
 * diamonds collect in a basin below. The magic wall runs once for everyone, so open all three
 * taps before it stops (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepI: CaveDef = {
  id: 'I',
  name: 'QUICKSILVER',
  hint: 'Open all three taps before the magic wall runs down.',
  intermission: false,
  colors: [11, 3, 1],
  diamondValue: 22,
  extraValue: 38,
  magicWallTime: 20,
  fill: { base: '.', items: [['r', 12], ['d', 5]] },
  levels: [
    { seed: 5901, diamonds: 18, time: 150 },
    { seed: 5902, diamonds: 22, time: 140 },
    { seed: 5903, diamonds: 26, time: 130 },
    { seed: 5904, diamonds: 30, time: 120 },
    { seed: 5905, diamonds: 34, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W.P.???????????????????????????????????W',
    'W???wwwww????????wwwww????????wwwww????W',
    'W???wrrrw????????wrrdw????????wrrrw????W',
    'W???wrdrw????????wrrrw????????wrrdw????W',
    'W???wrrrw????????wdrrw????????wrrrw????W',
    'W???wrrdw????????wrrrw????????wdrrw????W',
    'W???wsssw????????wsssw????????wsssw????W',
    'W??.......??????.......??????.......???W',
    'W??wwmmmww??????wwmmmww??????wwmmmww???W',
    'W??w     w??????w     w??????w     w???W',
    'W??w     w??????w     w??????w     w???W',
    'W??w     ..?????w     ..?????w     ..??W',
    'W??wwwwwww??????wwwwwww??????wwwwwww???W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W?????????????????????????????????.....W',
    'W?????????????????????????????????...X.W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
